'use es6';

import classNames from 'classnames';
import { HS_EMBED_WRAPPER_CLASS, HS_EMBED_CONTENT_WRAPPER_CLASS, RESPONSIVE_EMBED_FULL_WIDTH_CLASS } from '../../../constants/hsMedia';
import { getResponsiveEmbedWrapperStyles } from '../../../hsmedia/util';

// Component representation of new embeds
import { jsx as _jsx } from "react/jsx-runtime";
export default function StaticEmbed(props) {
  const {
    provider,
    responsive,
    hasScripts,
    dimensions,
    isFullWidth,
    html
  } = props;
  const wrapperProps = {
    'data-service': provider
  };
  if (hasScripts) {
    wrapperProps['data-script-embed'] = true;
  }
  if (responsive) {
    wrapperProps['data-responsive'] = true;
  }
  if (hasScripts || responsive) {
    wrapperProps.style = getResponsiveEmbedWrapperStyles(Object.assign({}, dimensions, {
      isFullWidth,
      centered: true,
      asAttr: true
    }));
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    // @bend-expect trellis-tokenized
    _jsx("div", Object.assign({
      className: classNames(HS_EMBED_WRAPPER_CLASS, isFullWidth && RESPONSIVE_EMBED_FULL_WIDTH_CLASS)
    }, wrapperProps, {
      children: /*#__PURE__*/_jsx("div", {
        className: HS_EMBED_CONTENT_WRAPPER_CLASS,
        dangerouslySetInnerHTML: {
          __html: html
        }
      })
    }))
  );
}